import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import throttle from 'lodash/throttle'
import { Flex, useMatchBreakpoints, Button, Link, Grid, Text } from '@crystals/uikit'
import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector, shallowEqual  } from "react-redux"
import { Dispatch } from "redux"
import { scroller } from 'react-scroll'
import Web3 from 'web3';
import Logo from './components/Logo'
import { addArticle } from "../../../store/actionCreators"
import Panel from './components/Panel'
import ConnectWallet from './components/ConnectWallet'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

const StyledNav = styled.nav<{ showMenu: boolean; opacity: boolean }>`
  position: fixed;
  top: ${({ showMenu }) => (showMenu ? 0 : `-90px`)};
  left: 0;
  transition: top 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 40px;
  padding-right: 40px;
  max-width: 1500px;
  width: 100%;
  height: 90px;
  z-index: 20;
  transform: translate3d(0, 0, 0);
  ${({ theme }) => theme.mediaQueries.md} {
    padding-left: 80px;
    padding-right: 80px;
  }
`

const BodyWrapper = styled.div`
  position: relative;
  display: flex;
`

const Inner = styled.div<{
  isPushed: boolean
  showMenu: boolean
  isMobile: boolean
}>`
  flex-grow: 1;
  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  // transform: translate3d(0, 0, 0);
  max-width: 100%;

  ${({ theme }) => theme.mediaQueries.nav} {
    margin-left: 0px;
`

const MenuButton = styled(Button)`
  background: #b07efa;
  text-align: center;
  box-shadow: 1px 1px 5px 1px rgb(14 14 44 / 19%);
  
  height: 50px;
  padding: 15px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: #00e0b8;
  font-family: Biennale, sans-serif;
  color: #07071c;
  font-size: 17px;
  line-height: 1;
  font-weight: 500;
  &:hover {
    opacity: 0.7;
  }
`

const MenuText = styled(Text)`
  font-family: 'fs',sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  color: #00dcb5;
  cursor: pointer;
`

const Menulink = styled(Link)`
  text-decoration: none !important;
  .link:hover {
    color: #3c64b1;
  }
`

const Navlink = styled(NavLink)`
  text-decoration: none !important;
  .link:hover {
    color: #3c64b1;
  }
`

const web3 = new Web3(window.ethereum);
const Menu: React.FC = ({ children }) => {
  const { isXl } = useMatchBreakpoints()
  const isMobile = isXl === false
  const [isPushed, setIsPushed] = useState(!isMobile ? false : !isMobile)
  const [showMenu, setShowMenu] = useState(true)
  const [opacity, setOpacity] = useState(false)
  const refPrevOffset = useRef(window.pageYOffset)
  const chainId = 56; // main net
  const [article, setCurrentAddr] = useState("");
  const articles: IArticle = useSelector(
    (state: ArticleState) => state.articles,
    shallowEqual
  )
  useEffect(() => {
    const handleScroll = () => {
      const currentOffset = window.pageYOffset
      const isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight
      const isTopOfPage = currentOffset === 0
      // Always show the menu when user reach the top
      if (isTopOfPage) {
        setShowMenu(true)
        setOpacity(false)
      }
      // Avoid triggering anything at the bottom because of layout shift
      else if (!isBottomOfPage) {
        if (currentOffset < refPrevOffset.current) {
          // Has scroll up
          setShowMenu(true)
          setOpacity(true)
        } else {
          // Has scroll down
          setShowMenu(false)
          setOpacity(false)
        }
      }
      refPrevOffset.current = currentOffset
    }
    const throttledHandleScroll = throttle(handleScroll, 200)

    window.addEventListener('scroll', throttledHandleScroll)
    return () => {
      window.removeEventListener('scroll', throttledHandleScroll)
    }
  }, [])
  // Find the home link if provided

  const goRecent = () =>
    scroller.scrollTo('RecentPlayed', {
      duration: 2000,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: 50,
    })
  
  const goHTP = () =>
    scroller.scrollTo('HowToPlay', {
      duration: 2000,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: 50,
    })

  const connectWallet = async () => {
    if (window.ethereum) {
      // const web3 = new Web3(window.ethereum)
      try {
        await window.ethereum.request({ method: "eth_requestAccounts" })
        const accounts = await window.ethereum.request({ method: 'eth_accounts' })
        addNewArticle(accounts[0]);
        setCurrentAddr(accounts[0]);
        window.ethereum.on('chainChanged', () => {
            window.location.reload();
        });

        await runAPP();

        return
      } 
      catch (error) {
        console.error(error)
      }
    }
  }

  const dispatch: Dispatch<any> = useDispatch()

  const addNewArticle = React.useCallback(
    (article1: IArticle) => dispatch(addArticle(article1)),
    [dispatch]
  )

  const runAPP = async () => {
    const currNetworkID = await web3.eth.net.getId()
    if (currNetworkID === chainId) {
      // tokenContract = await new web3.eth.Contract(TOKEN_ABI, TOKEN_ADDRESS);
    }
  }

  return (
    <Wrapper>
      <StyledNav showMenu={showMenu} opacity={opacity}>
        <Flex justifyContent="left" alignItems="center">
          <Logo
            isPushed={isMobile ? isPushed : false}
            togglePush={() => setIsPushed((prevState: boolean) => !prevState)}
            href="/"
            isMobile={isMobile}
          />
        </Flex>
        {!isMobile && (
          <Flex justifyContent="right" alignItems="center">
            <Grid
              gridTemplateColumns="1fr 1fr 1fr 1fr"
              gridColumnGap='25px'
            >
              <Flex alignItems="center">
                <Navlink to="/">
                  <MenuText className="link" onClick={() => goHTP()}>
                  &nbsp;
                  </MenuText>
                </Navlink>
              </Flex>
              <Flex alignItems="center">
                <Navlink to="/">
                  <MenuText className="link" onClick={() => goHTP()}>
                    How To Play
                  </MenuText>
                </Navlink>
              </Flex>
              <Flex alignItems="center">
                <Navlink to="/">
                  <MenuText className="link" onClick={() => goRecent()}>
                    Recent
                  </MenuText>
                </Navlink>
              </Flex>
              <ConnectWallet />              
            </Grid>
          </Flex>
        )}
      </StyledNav>
      <BodyWrapper>
        {isMobile && (
          <Panel
            isPushed={isMobile ? isPushed : true}
            togglePush={() => setIsPushed((prevState: boolean) => !prevState)}
            isMobile={isMobile}
            showMenu={isMobile ? showMenu : false}
            pushNav={setIsPushed}
          />
        )}
        <Inner isPushed={isPushed} showMenu={showMenu} isMobile={isMobile}>
          {children}
        </Inner>
      </BodyWrapper>
    </Wrapper>
  )
}

export default Menu
